'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var zh_CN = {
    // www
    www_title: '日历清单',
    www_homepage: '官网首页',
    www_keywords: '日历清单,日历,备忘录,桌面日历,万年历,日历计划,工作计划,待办,清单,日程,日程管理,便签,时间规划,打卡,记录本,时间管理,日程安排,倒数日,提醒,同步,日程表,行程,小日常,纪念日,日记,通知,笔记',
    www_description: '可以透明的显示在桌面壁纸上，提供农历、节气、节假日、法定假日显示。 双击即可编辑记录琐事、日程安排、重复任务等，还可以微信提醒。支持多端同步数据，实时共享数据，团队协作。',
    update_log: '更新日志',
    more_function: '更多功能介绍',
    slogan_text1: '拒绝拖延，效率人生',
    slogan_text2: '您的专属时间管理专家',
    slogan_text3: '让您的生活如开挂般精彩，一切尽在掌握',
    slogan_h5: '电脑版本可以透明的显示在桌面壁纸上，提供农历、节气、节假日、法定假日显示。双击即可编辑记录琐事、日程安排、重复任务等，还可以微信提醒。支持多端同步数据，实时共享数据，团队协作。',
    android_download: '下载APP',
    ios_download: 'AppStore安装',
    support_system: '已支持如下平台',
    windows_button: 'Win版本免费下载',
    mac_button: 'Mac版本',
    linux_button: 'Linux版本',
    linux_op_x86: 'X86 版本',
    linux_op_arm64: 'ARM64 版本',
    iphone_button: 'iPhone版',
    android_button: '安卓版',
    scan_download_phone: '扫描二维码下载手机版本',
    content_title1: '实时同步数据、协同办公',
    content_text1: '可以在PC电脑、Mac电脑、iPad、手机之间实时同步您的日程安排\n如果您是一个小团队，还可以实现团队协同办公',
    content_title_win1: '透明的贴在桌面壁纸上',
    content_text_win1: '与桌面完美融合。日历方式备忘。双击桌面即可快速编辑记录您的任务。',
    content_title2: '透明的贴在桌面壁纸上',
    content_title_win2: '免费壁纸皮肤',
    content_text_win2: '我们为您制作了几百张精美的皮肤，每天换一换心情。（仅限windows版本）',
    content_text2: '与桌面完美融合。双击桌面即可快速编辑记录您的任务',
    content_title3: '重复事件、微信提醒',
    content_text3: '重要的纪念日、信用卡还款、学生的课程等可以设置重复任务显示在日历上，还可以通过微信提醒',
    content_title_win3: '多端即时数据同步',
    content_text_win3: '您可以在电脑、手机、iPad、安卓Pad之间即时数据同步。',
    content_title4: '总有一种日历是您想要的',
    content_title_win4: '通知提醒，可微信提醒',
    content_text4: '无论您的从事行业是白领、学生、教师、IT、政府机构、金融，强大的日历设置功能，总能满足您的需求',
    content_text_win4: '可自定义重复、复杂的任务和提醒。如果您担心提醒不及时，还可以设置微信实时提醒。',
    content_title_win5: '倒数纪念日卡片',
    content_text_win5: '直接在桌面上显示精美的卡片，不忘记每一个重要的日子。',
    support: '客户支持',
    support_title: '日历清单-客戶支持',
    support_text1: '如果您有任何问题和建议，敬请邮件联系我们\nservice@xiaoweiyunfu.com',
    support_text2: '欢迎加入我们 QQ 群一起讨论产品。\n  PC群：',
    support_text3: '\n Mac群：',
    support_text4: '\n QQ群：529364157',
    help: '帮助',
    pay_title: '日历清单-功能介绍',
    cata_basic_intro_title: '功能介绍',
    cata_basic_intro_title1: '多端数据同步（手动）',
    basic_intro_title1: '多端数据同步',
    basic_intro_subtitle1: '无论您使用的是手机、电脑还是iPad，都可以轻松同步数据。',
    basic_intro_text1: '您需要在同步的设备上使用相同的账号登录。<p class="p" /><font color="#FE776D"> 哪个设备有数据，就需要在哪个设备上点击云按钮手动同步数据，这时候刚才记录的数据就在其他的设备上显示了。</font><p class="p" />我们提供了自动同步功能。开启自动同步后，您的数据将自动在设备之间进行同步，无需手动点击。',
    cata_basic_intro_title2: '日历备忘',
    basic_intro_title2: '日历备忘',
    basic_intro_subtitle2: '以日历的方式记录琐事，简洁而不简单。',
    basic_intro_text2: '您可以在日历上双击任何一个日期，即会弹出一个编辑框，您记录琐事。<p class="p" />回车换到新行就可以记录新的任务。',
    cata_basic_intro_title3: '提醒',
    basic_intro_title3: '提醒',
    basic_intro_subtitle3: '不容错过任何重要的事情，您可以添加提醒来实时提醒自己。',
    basic_intro_text3: '点击编辑框下方的提醒按钮，可以添加提醒。<p class="p" />提醒功能支持强大的个性化设置，您可以定义重复类型、结束日期、提醒次数和提醒时间等。',
    cata_basic_intro_title4: '倒数日',
    basic_intro_title4: '倒数日',
    basic_intro_subtitle4: '不能忘记每个重要的日子，您可以设置倒数日来提醒自己。',
    basic_intro_text4: '点击编辑框下方的倒数日按钮，可以添加倒数日。<p class="p" />我们将倒数日分为五个类别(生日、节日、纪念日、考试和默认)，并为您制作了精美的倒数日卡片，以便您更方便地提醒自己。',
    cata_basic_intro_title5: '任务标记完成',
    basic_intro_title5: '任务标记完成',
    basic_intro_subtitle5: '一键勾选完成，让您更有成就感地完成每个任务。',
    basic_intro_text5: '点击编辑第一个按钮，标记为完成。',
    cata_basic_intro_title6: '搜索',
    basic_intro_title6: ' 搜索 ',
    basic_intro_subtitle6: '您可以使用搜索功能，搜索历史记录。',
    basic_intro_text6: '点击日历右上方的菜单栏按钮，选择搜索。<p class="p" />在搜索栏中输入需要查找的关键字，系统会筛选出符合条件的日程安排，并显示在搜索栏下方。<p class="p" />双击搜索结果中的任何一个日程，即可进入编辑页面，对该日程进行修改。',
    cata_basic_intro_title7: '重复任务',
    basic_intro_title7: '重复任务',
    basic_intro_subtitle7: '如果有经常重复的日程，可以轻松设置重复任务。',
    basic_intro_text7: '在编辑框中，点击重复任务按钮。根据您的需求选择相应的重复时间和重复类型。',
    cata_basic_intro_title8: '教学周',
    basic_intro_title8: '教学周',
    basic_intro_subtitle8: '对于学生党和教师们，我们提供了显示教学周的功能。',
    basic_intro_text8: '点击日历右上角菜单按钮再点击设置，然后在设置对话框里选择高级，最后将当前学期所在的周数设置为“第一周”，这样日历左侧的周数就会显示为教学周。',
    cata_basic_intro_title9: '日历文字大小调整',
    basic_intro_title9: '日历文字大小调整',
    basic_intro_subtitle9: '可以设置日历界面字体、文字大小和文字颜色。',
    basic_intro_text9: '点击日历右上角菜单按钮再点击设置，然后在设置对话框选择日历，最后配置日历字体、大小和颜色。',
    cata_basic_intro_title10: '记录内容文字大小调整',
    basic_intro_title10: '记录内容文字大小调整',
    basic_intro_subtitle10: '单元格内的文字可以调整大小、字体和颜色。',
    basic_intro_text10: '点击日历右上角菜单按钮再点击设置，然后在设置对话框选择日单元格，最后配置日历字体、大小和颜色。',
    cata_basic_intro_title7_1: '免费壁纸皮肤',
    basic_intro_title7_1: '免费壁纸皮肤',
    basic_intro_subtitle7_1: '让桌面焕然一新，彰显您的个性。',
    basic_intro_text7_1: '点击日历右上角菜单按钮再点击壁纸皮肤。<p class="p" />如果您的菜单里没有壁纸皮肤选项，请<a href="/"> 点击这里 </a>下载最新版本。',

    //便签
    cata_basic_intro_title11: '便签',
    basic_intro_title11: '便签',
    basic_intro_subtitle11: '配备简洁易用的便签功能。',
    basic_intro_text11: '点击日历右上角插件按钮，即可看见便签相关功能，可新建便签或对便签进行设置。',

    //课程表
    cata_basic_intro_title12: '课程表',
    basic_intro_title12: '课程表',
    basic_intro_subtitle12: '配备功能完善的课程表功能。',
    basic_intro_text12: '点击日历右上角插件按钮，即可看见课程表功能，可新建课程表或对课程表进行设置。',

    //ai周报
    pay_new_upgrade_title13: 'AI周报',
    pay_new_upgrade_subtitle13: '点击即可生成工作周报，简单高效。',
    pay_new_upgrade_text13: '点击日历右上角插件按钮，即可看见AI周报功能入口，进入选择日期即可生成周报。',

    // 2024-09-26 新增独家介绍
    exclusive_title: '独家',
    cata_basic_intro_new_title0: '零广告',
    basic_intro_new_subtitle0: '我们坚信，无广告才是真效率',
    basic_intro_new_text0: '无论您是尊贵的付费用户还是免费用户，无论您在哪种平台上操作，日历清单都无任何广告侵扰，纯净陪伴。',

    cata_basic_intro_new_title1: '透明的贴在桌面壁纸上',
    basic_intro_new_subtitle1: '与系统桌面和壁纸无缝融合，桌面操作无阻',
    basic_intro_new_text1: '您在使用日历的同时，不影响鼠标对桌面的文件、图标的操作。',

    cata_basic_intro_new_title2: '跨月显示（即浮动月份）',
    basic_intro_new_subtitle2: '可跨月显示日历，不管是月初月底，均可看见前后一周或两周的日程',
    basic_intro_new_text2: '点击日历右上角的小箭头菜单，进入设置，在 日历 - 显示 中即可切换跨月显示或完整显示月份',

    cata_basic_intro_new_title3: '隐藏休息日',
    basic_intro_new_subtitle3: '可隐藏休息日，让您专注于工作日',
    basic_intro_new_text3: '点击日历右上角的小箭头菜单，进入设置，在 高级 - 每周休息日 中， 可自定义休息日及设置休息日是否显示。',

    cata_basic_intro_new_title4: '行、列数自定义',
    basic_intro_new_subtitle4: '可自定义行列数，打造专属日历视图', //灵活布局，打造专属日历视图
    basic_intro_new_text4: '点击日历右上角的小箭头菜单，进入设置，在 日历 - 显示 中， 自定义要显示的行数及列数，即可只显示几周或只显示每周的某几天',

    cata_basic_intro_new_title5: '全系统支持',
    basic_intro_new_subtitle5: 'Windows/Android/iOS/Mac/Linux全支持',
    basic_intro_new_text5: 'Android/iOS/Mac可在应用商店搜索“日历清单”下载安装。<p class="p" />Windows/Linux可在<a href="/">官网首页</a>下载。',

    group_intro_title1: '轻松共享您的日程',
    group_intro_subtitle1: '如果您是一个小团队，想和您的团队成员分享并管理日程，您可以试下日历清单的团队功能。',
    group_intro_text1: '点击日历右上角的个人按钮，然后选择「账户设置」，再选择「共享团队」，最后在页面的右上角可以添加您的成员。<p class="p" />为了便于您的管理，团队成员只能通过邮箱的方式添加。',
    group_intro_title2: '团队成员之间日程不共享',
    group_intro_subtitle2: '只想让团队成员看到编辑自己的任务和日程，团队成员之间互相不影响。',
    group_intro_text2: '在「账户设置」里点击「子账号」，然后添加子账号。<p class="p" />然后在「账户设置」里点击「共享团队」，在子账号显示控制栏里为团队成员选择对应的子账号。',
    group_intro_title3: '队成员不可编辑',
    group_intro_subtitle3: '当您只需共享日程，不想让团队成员编辑，可以设置为团队成员为只读。',
    group_intro_text3: '在「账户设置」里点击「共享团队」，找到对应的成员勾选只读，最后保存。',
    group_intro_title4: '便捷查看所有成员的日程',
    group_intro_subtitle4: '您可以一目了然的查看所有成员的日程。',
    group_intro_text4: '在子账号菜单里选择「主账号(显示所有成员内容)」<p class="p" />如果成员的显示的内容过多，可以将鼠标移动到日期上面，会显示完成的提示。',

    pay_new_upgrade_txt1: '只需使用相同的账号在其他设备上登录，数据即可立即同步显示，无需任何其他操作。',
    pay_new_upgrade_txt2: '不仅如此，为了确保您的历史数据安全，服务器也会同时备份您的历史数据。<p class="p" />打开编辑框，点击编辑框最后一个按钮，便可以查看所有的历史和相应的功能。',
    pay_new_upgrade_txt3: '点击日历右上角的个人按钮，然后选择「账户设置」，再选择「子账号」',
    pay_new_upgrade_txt4: '自动延期功能会获取前三天未完成的任务，并将它们延期到下一天。当任务被连续延期到第7天时，此功能会自动停止，不再继续延期任务。<p class="p" />延期的任务后面会标注「（9-10）」，代表是从哪个月哪一天开始自动延期的。<p class="p" />勾选完成后，任务将不再自动延期。',
    pay_new_upgrade_txt5: '有时候我们设置了提醒，但在手机上因为手机端的限制，这些提醒无法实时生效。而微信提醒则通过服务器发送消息，确保了实时性和准确性。<p class="p" />要使用微信提醒，您需要按照相关提示关注相应的微信公众号。',
    pay_new_upgrade_txt6: '点击「账户设置」，然后再点击「在线设备」。',
    pay_new_upgrade_txt7: '免费用户会有2个登录客户端的限制。',
    pay_new_upgrade_txt8: '免费用户云端仅存储最近6个月的数据。',
    pay_new_upgrade_txt9: '您可以通过微信搜索“日历清单”公众号联系客服。',
    cata_pay_new_upgrade_title: 'VIP会员功能',
    cata_pay_new_upgrade_title1: '多端即时同步数据（自动）',
    cata_pay_new_upgrade_title2: '历史记录自动备份，查看和删除',
    cata_pay_new_upgrade_title3: '子账号功能',
    cata_pay_new_upgrade_title4: '未完成任务自动延期',
    cata_pay_new_upgrade_title5: '微信提醒',
    cata_pay_new_upgrade_title6: '在线设备查看',
    cata_pay_new_upgrade_title7: '不限客户端登录数量',
    cata_pay_new_upgrade_title8: '云端永久存储数据',
    cata_pay_new_upgrade_title9: 'VIP专属客服',
    pay_new_upgrade_title1: '自动多端即时同步数据',
    pay_new_upgrade_title2: '历史记录功能',
    pay_new_upgrade_title3: '子账号功能',
    pay_new_upgrade_title4: '未完成任务自动延期',
    pay_new_upgrade_title5: '微信提醒',
    pay_new_upgrade_title6: '在线设备查看',
    pay_new_upgrade_title7: '不限客户端登录数量',
    pay_new_upgrade_title8: '云端永久存储数据',
    pay_new_upgrade_title9: 'VIP专属客服',
    pay_new_upgrade_subtitle1: '您可以在手机、电脑、iPad等多种设备之间实现即时同步数据',
    pay_new_upgrade_subtitle2: '历史记录将自动备份、查看和删除。',
    pay_new_upgrade_subtitle3: '当您在一天内记录了过多的任务时，您可以按照工作、生活等分类将它们分开显示。',
    pay_new_upgrade_subtitle4: '如果您在一天内记录了过多的任务并且没有完成，系统将自动将这些任务延期到下一天。',
    pay_new_upgrade_subtitle5: '微信实时提醒。',
    pay_new_upgrade_subtitle6: '在线设备管理，可以查看当前在线的客户端设备，并可操作当前显示的设备退出登录。',
    pay_new_upgrade_subtitle7: '同一个账号，不限制登录客户端设备的个数，并可以在家、公司、任何地方登录。',
    pay_new_upgrade_subtitle8: '会员用户数据将永久存储在云端，更换设备无忧，只需登录账号即可获取所有数据。',
    pay_new_upgrade_subtitle9: '会员使用中有任何问题，联系客服时将由专属客服优先为您解决。',

    pay_payment_method: '支付方式',
    pay_payment_wechat: '微信支付',
    pay_payment_paypal: 'PayPal',
    pay_upgrade_button: '立即升级',
    pay_upgrade_renew_button: '立即续费',
    pay_forpay_left: '为"',
    pay_forpay_right: '"支付',
    pay_payment_unit: '元',
    pay_three_month: '三个月',
    pay_one_year: '一年',
    pay_three_year: '三年',
    pay_original_price_threemonth: '原价 25 元',
    pay_original_price_oneyear: '原价 100 元',
    pay_original_price_threeyear: '原价 300 元',
    pay_application: '日历清单',

    cata_team_intro_title1: '与团队成员共享您的日程安排',
    cata_team_intro_title2: '团队成员之间日程不共享',
    cata_team_intro_title3: '团队成员权限设置',

    cata_user: '免费用户',
    cata_vip: 'VIP会员',
    cata_vip_team: 'VIP共享团队',

    group_upgrade_button: '立即升级团队会员',
    group_title: '日历清单 - 共享团队版本',

    about_us: '关于我们',
    copy_right: 'Copyright © 2018 - 现在。北京市海淀区翠微中里14号楼三层A460',

    wapper_title: "免费壁纸皮肤",
    wapper_desc_html: "<p>您使用的是Windows Store下载的安装程序，因为权限的问题，没有壁纸皮肤功能。 </p><p class='red'>想要使用此功能，请提前登陆并同步备份数据，然后卸载Windows Store版本。在<a href='/'>这里下载</a>最新的安装包并安装。</p>",

    v2_slogan_text: "您的专属时间管理专家",
    v2_feature_title: '透明显示<span class="gap">|</span>个性化壁纸<span class="gap">|</span>多端数据同步<span class="gap">|</span>便签<span class="gap">|</span>倒计时纪念日<span class="gap">|</span>日程提醒',
    v2_feature_title_baseintro: '透明显示<span class="gap"></span>个性化壁纸<span class="gap"></span>多端数据同步<span class="gap"></span>便签<span class="gap"></span>倒计时纪念日<span class="gap"></span>日程提醒',

    v2_content_title_note: "便签",
    v2_content_title_noad: "零广告",

    v2_content_text_note: "规划有序更高效，自选颜色随心配",
    v2_content_text_noad: "全渠道无广告干扰,享受纯净体验",

    v2_content_title_reminder: "通知提醒，可微信提醒",
    v2_content_text_reminder: "可自定义重复、复杂的任务和提醒。如果您担心提醒不及时，还可以设置微信实时提醒。",

    v2_content_title_countdown: "倒数纪念日卡片",
    v2_content_text_countdown: "直接在桌面上显示精美的卡片，不忘记每一个重要的日子。",

    v2_scan: "扫一扫",
    v2_down_phone: "免费下载手机app",

    v2_update_time: "更新时间",
    v2_update_ver: "最新版本",

    v2_feature_other: "其他特色功能",
    v2_feature_other_1_title: "个性化设置",
    v2_feature_other_1_html: "<li>日历上可显示农历、节气、节假日、法定假日</li><li>任意一天都可以设置您想要的背景颜色</li><li>自定义重复任务，可按天、周、月、年随心设置</li>",
    v2_feature_other_2_title: "智能化功能",
    v2_feature_other_2_html: "<li>新增任务只需要回车，极简设计才是真正的效率</li><li>浮动日历设计，一眼就可以查看上、下周的任务</li><li>  任务标记完成后，会自动移动到任务的末尾</li><li>  云端自动备份历史数据，轻松查看历史记录</li><li>  未完成任务可以自动延期到第二天</li>",
    v2_feature_other_3_title: "特色功能",
    v2_feature_other_3_html: "<li>导出Excel(PC电脑端)，可以整理一年的计划</li><li>搜索功能，快速查找记录过重要的任务</li><li>教学周设置，专为老师和学生设计</li><li>子账号，可以将您的工作、学习的任务分开记录</li><li>在线设备查看，并可以操作设备下线</li><li>小团队版本，可多人团队共享您的日历日程</li>",

    v2_about_us: "关于我们",

    v2_feature_exclusive_text: "独家功能",
    v2_feature_vip_text: "会员功能",
    v2_feature_normal_text: "基础功能",
    v2_feature_team_text: "团队功能",

    v2_ver_free_title: "免费版",
    v2_ver_free_desc: "适合个人本地使用",
    v2_ver_vip_title: "会员版",
    v2_ver_vip_desc: "适合个人使用，多设备同步更方便",
    v2_ver_team_title: "团队版",
    v2_ver_team_desc: "适合中小团队多人合作使用",

    v2_ver_free_equity: "包含功能:",
    v2_ver_vip_equity: "包含免费版全部功能，并额外提供:",
    v2_ver_team_equity: "包含免费版、会员版全部功能，并额外提供:",

    v2_ver_equity_support: "支持",
    v2_ver_include_base: "包含基础功能",
    v2_ver_include_vip: "包含会员功能",

    v2_down_btn_text: "立即免费下载",
    v2_sub_title: "拒绝拖延   效率人生",
    v2_www_link: "官网首页",
    v2_pay_btn_text: "立即升级",
    v2_team_days_desc: "10人每年",
    v2_team_btn: "查看团队版本",

    v2_button_down_xp: "下载winXP版本",
    v2_button_down_other: "查看其他版本"

};
exports["default"] = zh_CN;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./lang/zh_CN.js
// module id = 302
// module chunks = 0